export default __webpack_public_path__ + "static/media/CameraH1.370301b2.png";